export const formatInventoryDate = (
  date: string,
  locale: string = 'en-US',
  options: Intl.DateTimeFormatOptions = {}
): string => {
  if (!date) return '—';

  const parts = date.split('-').map((part) => parseInt(part, 10));
  if (parts.length !== 3 || parts.some((value) => Number.isNaN(value))) {
    return date;
  }

  const [year, month, day] = parts;
  const dateObj = new Date(Date.UTC(year, month - 1, day));

  const formatter = new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    timeZone: 'UTC',
    ...options,
  });

  return formatter.format(dateObj);
};
